import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { NotificationProvider } from './contexts/NotificationContext';
import Layout from './components/layout/Layout';
import LoginPage from './pages/auth/LoginPage';
import Dashboard from './pages/dashboard/Dashboard';
import ChantierList from './pages/chantiers/ChantierList';
import ChantierDetail from './pages/chantiers/ChantierDetail';
import VentesList from './pages/ventes/VentesList';
import AchatsList from './pages/achats/AchatsList';
import AchatDetail from './pages/achats/AchatDetail';
import RetoursList from './pages/retours/RetoursList';
import RetourDetail from './pages/retours/RetourDetail';
import ProductList from './pages/products/ProductList';
import ProductDetail from './pages/products/ProductDetail';
import ProductForm from './pages/products/ProductForm';
import LocationsList from './pages/locations/LocationsList';
import LocationForm from './pages/locations/LocationForm';
import SupplierList from './pages/suppliers/SupplierList';
import MagasinsList from './pages/magasins/MagasinsList';
import ImpressionsList from './pages/impressions/ImpressionsList';
import ImportExportPage from './pages/import-export/ImportExportPage';
import Users from './pages/users/Users';
import Profile from './pages/profile/Profile';
import AuditLogs from './pages/audit/AuditLogs';
import NotFound from './pages/NotFound';

function AppRoutes() {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  if (!user) {
    return <LoginPage />;
  }

  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/chantiers" element={<ChantierList />} />
        <Route path="/chantiers/:id" element={<ChantierDetail />} />
        <Route path="/ventes" element={<VentesList />} />
        <Route path="/achats" element={<AchatsList />} />
        <Route path="/achats/:id" element={<AchatDetail />} />
        <Route path="/retours" element={<RetoursList />} />
        <Route path="/retours/:id" element={<RetourDetail />} />
        <Route path="/products" element={<ProductList />} />
        <Route path="/products/:id" element={<ProductDetail />} />
        <Route path="/products/new" element={<ProductForm />} />
        <Route path="/products/:id/edit" element={<ProductForm />} />
        <Route path="/products/locations" element={<LocationsList />} />
        <Route path="/products/locations/new" element={<LocationForm />} />
        <Route path="/products/locations/:id/edit" element={<LocationForm />} />
        <Route path="/suppliers" element={<SupplierList />} />
        <Route path="/magasins" element={<MagasinsList />} />
        <Route path="/magasins" element={<MagasinsList />} />
        <Route path="/impressions" element={<ImpressionsList />} />
        <Route path="/import-export" element={<ImportExportPage />} />
        {(user.role === 'admin' || user.role === 'responsable_bureau') && (
          <Route path="/users" element={<Users />} />
        )}
        {user.role === 'admin' && (
          <Route path="/audit" element={<AuditLogs />} />
        )}
        <Route path="/profile" element={<Profile />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Layout>
  );
}

function App() {
  return (
    <Router>
      <AuthProvider>
        <NotificationProvider>
          <div className="min-h-screen bg-gray-50">
            <AppRoutes />
          </div>
        </NotificationProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;